import PropTypes from 'prop-types';
import React from 'react';
import Thumbnail from './thumbnail';
import SeeAllSlidesAd from '../../../../ad/see_all_slides_ad';
import {map, isEmpty} from 'lodash';

const ThumbnailRow = ({
  adPosition,
  adsState,
  handleThumbnailClick,
  thumbnails
}) => (
  <div className="thumbnail-row-container">
    <div className="thumbnail-row">
      {
        map(thumbnails, (thumbnail, i) => (
          <Thumbnail key={i}
            handleClick={handleThumbnailClick}
            {...thumbnail}
          />
        ))
      }
    </div>
    {
      !isEmpty(adPosition) && (
        <SeeAllSlidesAd adsState={adsState}
          adPosition={adPosition}
        />
      )
    }
  </div>
);

ThumbnailRow.propTypes = {
  adsState: PropTypes.object.isRequired,
  thumbnails: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  handleThumbnailClick: PropTypes.func.isRequired,
  adPosition: PropTypes.string
};

export default ThumbnailRow;
